import React from "react"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { TextField } from "@material-ui/core"

export function ColumnFilter({ options, label, value, handler }) {
    const cleanFilter = [...new Set(options.filter((o) => o != null))].sort();
    return <>
        <Autocomplete
            size="small"
            options={cleanFilter}
            value={value}
            fullWidth
            style={{ flex: 1 }}
            onChange={(event, newValue) => handler(newValue)}
            renderInput={(params) => <TextField {...params} label={label} fullWidth variant="outlined" InputLabelProps={{ shrink: true }} />}
        />
    </>
}

export const HoldingTableColumns = [
    {
        field: "id",
        headerName: "Error ID",
        flex: 2,
    },
    {
        field: "level",
        headerName: "Level",
        flex: 2,
    },
    {
        field: "appName",
        headerName: "Application",
        flex: 2,
    },
    {
        field: "message",
        headerName: "Message",
        flex: 2,
    },
    {
        field: "exception",
        headerName: "Exception",
        flex: 2,
    },
    {
        field: "className",
        headerName: "Class",
        flex: 2,
    },
    {
        field: "memberName",
        headerName: "Member",
        flex: 2,
    },
    {
        field: "machineName",
        headerName: "Machine",
        flex: 2,
    },
    {
        field: "date",
        headerName: "Date",
        flex: 2,
    },
]